import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Modal from 'react-responsive-modal'
import Input from '@components/FormInput'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import { logoMolaBig } from '@global/imageUrl'
import styles from './AddEmailPhoneModal.css'
import Auth from '@api/auth'
import _get from 'lodash/get'

class AddEmailPhoneModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isFormValid: false,
      formControls: {
        phone: {
          value: '',
          label: 'Masukkan nomor telepon',
          placeholder: '08XX-XXX-XXXX',
          valid: true,
          touched: false,
          error: '',
        },
      },
    }
  }

  componentDidMount() {
    // if (this.props.redirectURL) {
    //   document.cookie = `redirect_uri=${this.props.redirectURL}; max-age=${3600}; path=/;`
    // }
  }

  validatePhone = async phone => {
    const {
      runtime: { csrf },
    } = this.props
    let res = true

    const result = await Auth.validateEmailPhoneNumber({ phone, csrf })
    if (result.meta.status === 'success') {
      if (result.data && result.data.status == -1) {
        res = true
      } else {
        res = false
      }
    } else {
      res = false
    }
    return res
  }

  validate = (name, value) => {
    const { locale, formControls } = this.state
    let valid = {
      isValid: true,
      errorMessage: '',
    }
    // const reg = /^(^\+62\s?|^0)(\d{2,4}-?){2}\d{2,6}$/g
    // let validFormat = reg.test(value)

    switch (name) {
      case 'phone':
        if (!value) {
          const errorMess = _get(this.props.configParams, `errorCodes.add_email_phone.ERROR_INPUT_PHONE`, 'Nomor telepon tidak boleh kosong')
          valid.errorMessage = errorMess
        } else if (value && value.length < 8) {
          const errorMess = _get(this.props.configParams, `errorCodes.add_email_phone.ERROR_INPUT_PHONE_MIN`, 'Nomor telepon terlalu pendek (Min 8 angka)')
          valid.errorMessage = errorMess
        } else if (value && value.length > 15) {
          const errorMess = _get(this.props.configParams, `errorCodes.add_email_phone.ERROR_INPUT_PHONE_MAX`, 'Nomor telepon terlalu panjang (Maks 15 angka)')
          valid.errorMessage = errorMess
        }
        // } else if(value && !validFormat) {
        //   valid.errorMessage = "Nomor telepon salah format"
        // }
        break
      default:
        valid.isValid = true
    }

    valid.isValid = valid.errorMessage ? false : true
    return valid
  }

  handleVerifButton = () => {
    const formData = {}
    const errorMess = _get(this.props.configParams, `errorCodes.add_email_phone.ERROR_INPUT_PHONE_EXIST`, 'Nomor telepon sudah digunakan')
    this.validatePhone(this.state.formControls['phone'].value).then((x) => {
      const updatedControls = {
        ...this.state.formControls,
      }
  
      const updatedFormElement = {
        ...updatedControls['phone'],
      }
      
      if(x == false){
        updatedFormElement.valid = false
        updatedFormElement.error = errorMess
        updatedControls['phone'] = updatedFormElement

        this.setState({formControls: updatedControls})
      }
      else {
        for (let formElementId in this.state.formControls) {
          if (this.state.formControls[formElementId].value) {
            formData[formElementId] = this.state.formControls[formElementId].value
          }
        }
        if (this.props.handleOnVerification) {
          this.props.handleOnVerification(formData)
        }
      }
    })
  }

  handleVerifButtonSecond = () => {
    const formData = {}
    for (let formElementId in this.state.formControls) {
      if (this.state.formControls[formElementId].value) {
        formData[formElementId] = this.state.formControls[formElementId].value
      }
    }
    if (this.props.handleOnVerification) {
      this.props.handleOnVerification(formData)
    }
  }

  handleClose = () => {
    this.props.onModalCancel()
  }

  onChangePhone = event => {
    let name = ''
    let value = ''
    if (event.target) {
      name = event.target.name
      value = event.target.value
    }
    if (name == 'phone') {
      const reg = /^\d*\+?\d*$/g
      const reg2 = /^\d*$/g
      if (!reg.test(value)) {
        return
      }
      value = value.replace(/^(\+?628|08)/, '08')
      if (value && value.slice(1) && !reg2.test(value.slice(1))) {
        return
      }
    }

    const updatedControls = {
      ...this.state.formControls,
    }

    const updatedFormElement = {
      ...updatedControls[name],
    }

    updatedFormElement.value = value
    updatedFormElement.touched = true

    let valid = this.validate(name, updatedFormElement.value)

    updatedFormElement.valid = valid.isValid
    updatedFormElement.error = valid.errorMessage
    updatedControls[name] = updatedFormElement

    let isFormValid = true
    for (let inputIdentifier in updatedControls) {
      isFormValid = updatedControls[inputIdentifier].valid && isFormValid
    }

    this.setState({
      formControls: updatedControls,
      isFormValid,
    })
  }

  renderDesktop = () => {
    const { phone } = this.state.formControls
    const { isFormValid } = this.state
    const titleEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_title', 'Tambah Email')
    const titlePhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_title', 'Tambah Nomor Telepon')
    const titleNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_title', 'Anda belum memiliki email')
    const subtitleEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_subtitle', 'Untuk melindungi keamanan akun dan kemudahan menikmati layanan, silahkan tambahkan email anda.')
    const subtitlePhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_subtitle', 'Nomor telepon yang anda masukkan bisa digunakan untuk login')
    const subtitleNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_subtitle', 'Anda membutuhkan email untuk mengatur password. \n Tambah email dan atur password sekarang.')
    const buttonEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_button', 'Tambah Sekarang')
    const buttonPhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_button', 'Verifikasi')
    const buttonNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_button', 'Tambah Sekarang')
    const buttonCancel = _get(this.props.configParams, 'naming.emailphone.modal_cancel_button', 'Nanti Saja')
    let titleModal
    let subTitleModal
    let submitLabel
    if (this.props.type == 'phone') {
      titleModal = titlePhone
      subTitleModal = subtitlePhone
      submitLabel = buttonPhone
    } else if (this.props.type == 'noemail') {
      titleModal = titleNoEmail
      subTitleModal = subtitleNoEmail
      submitLabel = buttonNoEmail
    } else {
      titleModal = titleEmail
      subTitleModal = subtitleEmail
      submitLabel = buttonEmail
    }

    return (
      <>
        <Modal
          open={this.props.isModalOpen}
          classNames={{
            modal: [styles.addemailphone__modal_container, this.props.className].join(' '),
            overlay: styles.device__overlay_container,
          }}
          onClose={this.handleClose}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          showCloseIcon={false}
          center
        >
          <div className={styles.addemailphone__m_container}>
            <div className={styles.addemailphone__m_wrapper}>{titleModal}</div>
            {/* {this.props.isMobile ? (
              ''
            ) : (
                <button type="button" className={s.device__button_close_modal} onClick={this.handleClose} />
              )} */}
            <div className={styles.addemailphone__m_wrapper_sub}>{subTitleModal}</div>
            {this.props.type == 'phone' && (
              <div className={styles.addemailphone__m_text_wrapper}>
                {/* <label className={styles.addemailphone__input_label}>Nomor Telepon</label>
                <input type="text" className={styles.addemailphone__input_phone} id="phone" name="phone" value={isPhone} onChange={this.onChangePhone}/> */}
                <Input
                  id="phone"
                  name="phone"
                  className={styles.addemailphone__form_wrapper}
                  label="Nomor Telepon"
                  onChange={this.onChangePhone}
                  value={phone.value}
                  errorMessage={phone.error}
                  isError={!phone.valid && phone.touched}
                  placeholder={phone.placeholder}
                  type="text"
                />
              </div>
            )}
            <div className={styles.addemailphone__m_button_wrapper}>
              <button className={styles.addemailphone__m_button_accept} type="button" disabled={this.props.type == "phone"? !isFormValid : false} onClick={() => this.props.type == "phone"? this.handleVerifButton() : this.handleVerifButtonSecond()}>
                {submitLabel}
              </button>
              <button
                className={styles.addemailphone__m_button_decline}
                type="button"
                onClick={() => this.handleClose()}
              >
                {buttonCancel}
              </button>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  renderMobile = () => {
    const { phone } = this.state.formControls
    const { isFormValid } = this.state
    const titleEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_title', 'Tambah Email')
    const titlePhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_title', 'Tambah Nomor Telepon')
    const titleNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_title', 'Anda belum memiliki email')
    const subtitleEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_subtitle', 'Untuk melindungi keamanan akun dan kemudahan menikmati layanan, silahkan tambahkan email anda.')
    const subtitlePhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_subtitle', 'Nomor telepon yang anda masukkan bisa digunakan untuk login')
    const subtitleNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_subtitle', 'Anda membutuhkan email untuk mengatur password. \n Tambah email dan atur password sekarang.')
    const buttonEmail = _get(this.props.configParams, 'naming.emailphone.modal_add_email_button', 'Tambah Sekarang')
    const buttonPhone = _get(this.props.configParams, 'naming.emailphone.modal_add_phone_button', 'Tambah Sekarang')
    const buttonNoEmail = _get(this.props.configParams, 'naming.emailphone.modal_no_email_button', 'Tambah Sekarang')
    const buttonCancel = _get(this.props.configParams, 'naming.emailphone.modal_cancel_button', 'Nanti Saja')
    let titleModal
    let subTitleModal
    let submitLabel
    if (this.props.type == 'phone') {
      titleModal = titlePhone
      subTitleModal = subtitlePhone
      submitLabel = buttonPhone
    } else if (this.props.type == 'noemail') {
      titleModal = titleNoEmail
      subTitleModal = subtitleNoEmail
      submitLabel = buttonNoEmail
    } else {
      titleModal = titleEmail
      subTitleModal = subtitleEmail
      submitLabel = buttonEmail
    }

    return (
      <>
        <Modal
          open={this.props.isModalOpen}
          classNames={{
            modal: [styles.addemailphone__modal_container_mobile, this.props.className].join(' '),
            overlay: styles.device__overlay_container,
          }}
          onClose={this.handleClose}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          showCloseIcon={false}
          center
        >
          <div className={styles.addemailphone__m_container}>
            <div className={styles.addemailphone__m_wrapper_mobile}>{titleModal}</div>
            {/* {this.props.isMobile ? (
              ''
            ) : (
                <button type="button" className={s.device__button_close_modal} onClick={this.handleClose} />
              )} */}
            <div className={styles.addemailphone__m_wrapper_sub_mobile}>{subTitleModal}</div>
            <div className={styles.addemailphone__m_button_wrapper_mobile}>
              <button
                className={styles.addemailphone__m_button_decline}
                type="button"
                onClick={() => this.handleClose()}
              >
                {buttonCancel}
              </button>
              <button className={styles.addemailphone__m_button_accept} type="button" onClick={() => this.handleVerifButtonSecond()}>
                {submitLabel}
              </button>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  render() {
    const { isMobile = false } = this.props
    return (
      <>
        {!isMobile && this.renderDesktop()}
        {isMobile && this.renderMobile()}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  }
}

export default compose(withStyles(styles), connect(mapStateToProps))(AddEmailPhoneModal)
